import { account } from './account.js';
import { settings } from './storage.js';
import { codecSupport } from './codecs.js';
import { isHlsUrl } from './utils.js';

/* Conversión de audio en el servidor (server/transcode.js): cuando el archivo lleva audio
   Dolby/DTS que este dispositivo no decodifica, el reproductor pide el vídeo a través de
   /transcode, que copia el vídeo y convierte solo el audio a AAC. */

/* Conversión local dentro de la app de Windows (electron/transcode-server.js): un ffmpeg propio en 127.0.0.1. Se pregunta
   al arrancar por el puente de Electron; si está, tiene prioridad sobre el servidor (no gasta red ni CPU ajena). */
let local = null;

export async function initLocalTranscode(bridge) {
    if (!bridge || typeof bridge.transcode !== 'function') return null;
    try {
        const info = await bridge.transcode();
        local = info && info.available && info.base && info.token ? info : null;
    } catch (e) {
        local = null;
    }
    return local;
}

export function localTranscodeAvailable() {
    return !!local;
}

/** Dirección del servidor local de la app de Windows (también sirve la página puente del tráiler), o ''. */
export function localServerBase() {
    return local && local.base ? local.base : '';
}

/** Último error de la conversión local (lo que dijo ffmpeg), para la pantalla de error. */
export async function localTranscodeLastError(bridge) {
    if (!local || !bridge || typeof bridge.transcode !== 'function') return '';
    try { const info = await bridge.transcode(); return (info && info.lastError) || ''; } catch (e) { return ''; }
}

export function transcodeAvailable() {
    if (local) return true;
    return !!(account.transcode && account.online !== false && (!account.enabled || account.token));
}

/** Decide si un vídeo bajo demanda debe pasar por la conversión, según ajustes y códecs. */
export function shouldTranscode(info, url) {
    if (!transcodeAvailable() || !url || isHlsUrl(url)) return false;
    const mode = settings.get('transcodeAudio') || 'auto';
    if (mode === 'never') return false;
    if (mode === 'always') return true;
    const sup = codecSupport(info || {});
    return sup.known && !sup.audioOk;
}

export function transcodeUrl(rawUrl, startSeconds = 0, audioIndex = 0) {
    const t = Math.max(0, Math.floor(startSeconds || 0));
    if (local) return local.base + '/transcode?url=' + encodeURIComponent(rawUrl) + '&t=' + t + (audioIndex ? '&a=' + audioIndex : '') + '&token=' + encodeURIComponent(local.token);
    let u = account.baseUrl() + '/transcode?url=' + encodeURIComponent(rawUrl) + '&t=' + t;
    if (audioIndex) u += '&a=' + audioIndex;
    if (account.token) u += '&token=' + encodeURIComponent(account.token);
    return u;
}
